import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

const componentName = 'buttons-collection';

export default <FunctionalComponentOptions>{
    name: componentName,

    functional: true,

    props: {
        kind: {
            type: String,
            default: 'single',
            validator: (v: string) => v == '' || /(single|double|multiple|vertical)/.test(v)
        },
        forceAlign: {
            type: String,
            default: undefined,
            validator: (v: string) => v == '' || /(left|center|right)/.test(v)
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'div', { class: [ wrapperClasses(ctx), ctx.data.staticClass]}, [
                ctx.slots().title && h('p', { class: 'buttons-collection__title wok--body-short-02' }, [
                    ctx.slots().title
                ]),
                h('div', { class: 'buttons-collection' }, [
                    ctx.slots().actions
                ])
            ]
        )
    }
}

function wrapperClasses(ctx: RenderContext) {
    return {
        'buttons-collection__wrapper': true,
        [`buttons-collection--${ctx.props.kind}`]: ctx.props.kind,
        [`buttons-collection--${ctx.props.forceAlign}`]: ctx.props.forceAlign
    }
}